export const BASE_URLS = {
  UIC_DEV: "https://rozie-shared-component-development.rozie.ai",
  UIC_SBX: "https://rozie-shared-component-sandbox.rozie.ai",

  WBU_DEV: "https://rozie-shared-webchat-development.rozie.ai",
  WBU_SBX: "https://rozie-shared-webchat-sandbox.rozie.ai"
}
